exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.user-dialog .el-dialog__body {\n    padding: 30px 20px 70px 20px;\n}\n", ""]);

// exports
